import { useRef } from "react";
import { Button } from "@postenbring/hedwig-react";
import { useHandleCalculate } from "./hooks/useHandleCalculate";

export const CalculateButton = ({ serviceUrlPriceCalc, labels }) => {
    const submitButtonRef = useRef(null);

    const { handleCalculate, loading } = useHandleCalculate({ serviceUrlPriceCalc, labels });

    const handleClick = (e) => {
        e.preventDefault();
        handleCalculate();
    };

    return (
        <Button
            data-color="bring"
            variant="primary"
            type="submit"
            ref={submitButtonRef}
            onClick={handleClick}
            disabled={loading}
            fullWidth="mobile"
        >
            {loading ? labels.calculating : labels.calculate}
        </Button>
    );
};
